<ng-container *ngIf="code">
  <!-- tap anywhere on the code (or the copy button) to copy it -->
  <div
    class="codeBox"
    [class.copied]="justCopied"
    role="button"
    tabindex="0"
    [title]="'copyCode' | translate"
    (click)="copyCode()"
    (keydown.enter)="copyCode()"
    (keydown.space)="copyCode(); $event.preventDefault()"
  >
    <div class="codeBox__head">
      <span class="codeBox__lbl">{{ 'deviceCode' | translate }}</span>
      <button
        type="button"
        class="codeBox__copy"
        [attr.aria-label]="'copyCode' | translate"
        (click)="copyCode(); $event.stopPropagation()"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>

    <div class="letterContainer" [splitLetters]="code.code"></div>

    <div class="cdwn">
      <div class="cdwn-cap">
        <ng-container *ngIf="!justCopied">
          <mat-icon>timer</mat-icon> {{ 'codeRefreshesIn' | translate }} <b>{{ remainingTime }}</b>
        </ng-container>
        <span class="copied" *ngIf="justCopied"><mat-icon>check_circle</mat-icon> {{ 'copied' | translate }}</span>
      </div>
    </div>

    <!-- kod je na ekranu, ali prijava ne stiže do servera (2+ neuspeha zaredom); ne ponavlja se
         kad prekid već prikazuje status veze iznad (login ekran) -->
    <div class="codeBox__warn" *ngIf="loginFailStreak >= 2 && !connectionIssueShown">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'codeSignin.loginOffline' | translate }}</span>
    </div>
  </div>
</ng-container>

<!-- Kod još nije stigao: status, a posle neuspeha i razlog. Novi pokušaj ide na 5 s (i odmah kad
     se mreža vrati), bez kraja — dok server ne odgovori. Dok status veze iznad (login ekran)
     prikazuje prekid, razlog je samo u statusu: kod otvoren klikom pokazuje „Preuzimam kod…",
     a kod prikazan sam od sebe (KD) se ne prikazuje. -->
<div class="codeStatus" *ngIf="!code && (!connectionIssueShown || openedByUser)" role="status" aria-live="polite">
  <div class="codeStatus__head">
    <mat-icon class="codeStatus__spin">sync</mat-icon>
    <span>{{ (failure && !connectionIssueShown ? 'codeSignin.unavailable' : 'codeSignin.loading') | translate }}</span>
  </div>
  <ng-container *ngIf="!connectionIssueShown && failureMessage as msg">
    <div class="codeStatus__reason">{{ msg.key | translate: msg.params }}</div>
    <div class="codeStatus__retry">{{ 'codeSignin.retrying' | translate: { attempt: failedAttempts + 1 } }}</div>
  </ng-container>
</div>
